import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse, ListItemButton, ListItemText } from "@mui/material";
import { LngLat, Map } from "mapbox-gl";
import React, { useEffect, useRef, useState } from "react";
import Avatar from "../../components/Avatar";
import { FarmerGroup, GroupModel } from "../../models/organisation/GroupModel";
import '../../pages/styles/colors.scss';
import { ReactComponent as IconOpen } from "../../rsc/ic_open_arrow.svg";
import { ReactComponent as Plot } from "../../rsc/ic_supply.svg";
import './GroupCard.scss';
import { t } from "i18next";
import { colorYellowLight } from "../../rsc/colors/colors";
import { updatePolygonGroup } from "../../models/MapBoxGroupModel";
import { Landplot } from "../../models/organisation/Landplot";
import { zoomForCoordinates } from "../../models/MapBoxDataModel";

type FarmerProps = {
    farmer: FarmerGroup
    setFarmerSelected: any
    isOpen: boolean
}

function FarmerRow({ farmer, setFarmerSelected, isOpen }: FarmerProps) {

    const [open, setOpen] = useState(false)

    useEffect(() => {
        setOpen(isOpen)
    }, [isOpen])

    return <div>
        <ListItemButton style={{ gap: "4px", padding: "10px 10px", background:open ? colorYellowLight : ''}} onClick={() => {setOpen(!open); setFarmerSelected(farmer)}}>
            <Avatar style={{ height: "40px", width: "40px" }}
                uri={farmer.person?.user?.avatar_url}
                firstname={farmer.person?.firstname}
                lastname={farmer.person?.lastname} />
            <p >{farmer.person.getFullName()}</p>
            <p style={{ flex: 1 }}>(Plots: {farmer.plots.length})</p>
            {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open} unmountOnExit timeout={'auto'}>
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                cursor: "pointer",
                marginRight:"34px",
                marginLeft: "54px",
                padding: "4px 0",
            }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    {
                        farmer.plots.map(p => {
                            return (
                                <div key={p.id} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <Plot style={{ width: "25px", height: "25px" }} />
                                    <p style={{flex:1}}>{p.name}</p>
                                    <div style={{display:"flex"}}>
                                        <p>{p.size} {t('hectares')}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </Collapse>
    </div>
}

type Props = {
    group: GroupModel
    setGroupSelected: any
    isOpen: boolean
    map: Map
}

export function GroupCard({ group, setGroupSelected, isOpen, map }: Props) {

    const [componentWidth, setComponentWidth] = useState(0);
    const componentRef = useRef(null);
    const [farmerSelected, setFarmerSelected] = useState<FarmerGroup>(undefined)

    // Function to update component width
    const updateWidth = () => {
        if (componentRef.current) {
            setComponentWidth(componentRef.current.getBoundingClientRect().width);
        }
    };

    useEffect(() => {
        updateWidth();

        window.addEventListener('resize', updateWidth);

        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, []);

    const textStyle: React.CSSProperties = {
        textAlign: isOpen ? 'center' : 'start',
        transform: isOpen ? 'translateX(0%)' : 'translateX(0%)',
        transition: 'transform 1s ease',
      };

      useEffect(() => {
        if (map) {
            var p: Landplot[]
            if (farmerSelected) {
                p = farmerSelected.plots
            } else {
                p = group.plots
            }
            updatePolygonGroup(map, p)
            const plotCoords = [...p].flatMap(p => p.polygon ? p.polygon.coordinates[0].map(co => new LngLat(co[0], co[1])) : [])
            zoomForCoordinates(map, plotCoords)    
        }
        // eslint-disable-next-line
    }, [farmerSelected])

    return (
        <div key={group.id} style={{
            display: "flex",
            flexDirection: "column",
            overflow: "visible",
            position: "relative"
        }} >
            <div ref={componentRef} style={{ display: "flex", width: "100%", position: "relative" }}>
                <div className={isOpen ? `grow-animation lighGreyColorHoverGreenPale` : 'shrink-animation lighGreyColorHoverGreenPale'}
                style={{ cursor: "pointer"}}
                onClick={() => { setGroupSelected(group) }}>
                    <div id="button-expand" className={isOpen ? "middle-animation" : 'start-animation'} style={{ alignItems:"center",'--maxWidth': `${componentWidth / 2 - 200}px`, display:"flex", padding:"10px", gap:"5px"} as React.CSSProperties}>
                        <ListItemText style={textStyle}>
                            {group.name}
                        </ListItemText>
                        <IconOpen className={isOpen ? 'rotate90-animation' : 'rotate0-animation'} style={{ height: "30px", width: "30px", flexShrink:0 }} />
                    </div>
                </div>
            </div>
            <Collapse in={isOpen} timeout={'auto'}>
                <div style={{
                    display: "flex",
                    cursor: "pointer",
                    padding: "4px 0",
                    position:"relative"
                }}>
                    <div style={{ display: "flex", flexDirection: "column", width: "400px" }}>
                        {
                            group.farmers.map(f => <FarmerRow key={f.person.id} isOpen={farmerSelected?.person?.id === f?.person?.id} setFarmerSelected={(f: FarmerGroup) => setFarmerSelected(farmerSelected && farmerSelected?.person?.id === f?.person?.id ? undefined : f)} farmer={f} />)
                        }
                    </div>
                    <div style={{ flex:1, height: 500, position:"sticky", top:"100px"}}>
                        <div id={`mapGroup-${group.id}`} style={{ width: "100%", height: "100%" }}></div>
                    </div>
                </div>
            </Collapse>
        </div >
    )
}